import * as React from 'react'
import * as _ from 'lodash'

const rangeSelectorStyle = {
  color: '#aaa',
  fontSize: '11px',
  lineHeight: '45px',
  // position: 'relative',
  width: '100%',
  display: 'flex',
  height: '40px',
  borderRadius: '6px',
  paddingLeft: '15px',
  border: 'none',
  backgroundColor: '#373737',
  marginBottom: '2px',
}

const spinnerStyle = {
  textTransform: 'uppercase',
  fontFamily: '"Gotham SSm A", "Gotham SSm B", "Helvetica Neue", sans-serif',
  fontSize: '11px',
  letterSpacing: '0.1em',
  height: '40px',
  // marginRight: '180px',
  flexGrow: 2,
  whiteSpace: 'nowrap'
}

const inputStyle = {
  display: 'block',
  height: '40px',
  color: '#6d97a4',
  background: 'none',
  border: 'none',
  fontSize: '15px',
  width: '100px',
  textAlign: 'right',
  marginRight: '15px'
}

const controlStyle = {
  height: '40px',
  display: 'flex'
}

const decreaseStyle = {
  background: '#373737',
  textShadow: '1px 1px 0 black',
  backgroundColor: '#373737',
  backgroundImage: 'linear-gradient(to right, #373737, #2f2f2f)',
  width: '40px',
  height: '40px',
  fontSize: '20px',
  display: 'block',
  textAlign: 'center',
  float: 'left',
  borderLeft: '2px solid #464646'
}

const increaseStyle = Object.assign({}, decreaseStyle, {
  borderRadius: '0 4px 4px 0'
})

export default class MdSpinner extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      displayValue: this.formatValue(props.amount)
    }
  }
  public handleInputChange(e) {
    e.preventDefault()
    const inputValue = e.target.value

    if (Number.isNaN(Number(inputValue))) {
      return
    }
    this.setState({
      displayValue: inputValue
    })
  }
  public handleInputBlur(e) {
    this.propogateDisplayValueChange(this.state.displayValue)
  }
  public formatValue(newValue: any) {
    return _.round(newValue * this.props.divisor, 2).toFixed(2)
  }
  public adjustValue(adjustmentAmount) {
    let displayValue = (this.props.amount + adjustmentAmount) * this.props.divisor
    this.propogateDisplayValueChange(displayValue)
  }
  public propogateDisplayValueChange(displayValue) {
    this.props.valueChangeFn(this.enforceMaxAndMin(displayValue) / this.props.divisor)
  }
  public componentWillReceiveProps(nextProps) {
    this.setState({
      displayValue: this.formatValue(nextProps.amount)
    })
  }
  private enforceMaxAndMin(displayVal) {
    let max = this.props.maximumDisplayValue
    let min = this.props.minimumDisplayValue
    if (_.isNumber(max)) {
        displayVal = Math.min(max, displayVal)
    }
    if (_.isNumber(min)) {
        displayVal = Math.max(min, displayVal)
    }
    return displayVal
  }
  render() {
    const editableInput = (
      <input size={2}
        value={this.state.displayValue}
        onChange={this.handleInputChange.bind(this)}
        onBlur={this.handleInputBlur.bind(this)}
        style={inputStyle}
      />
    )
    const nonEditableInput = (
      <input size={2}
        defaultValue={this.state.displayValue}
        style={Object.assign({}, inputStyle, {
          paddingRight: '10px'
        })}
        disabled
      />
    )
    const nonEditableRangeSelectorStyle = Object.assign({}, rangeSelectorStyle, {
      paddingLeft: '40px',
      paddingRight: '40px'
    })
    return (
      <div>
        {this.props.readOnly ? (
          <div style={nonEditableRangeSelectorStyle} >
            {this.props.title ? (
              <div style={spinnerStyle} >
                {this.props.title}
              </div>
            ) : null}
            {nonEditableInput}
          </div>
        ) : (
            <div style={rangeSelectorStyle} >
              <div style={spinnerStyle} >
                {this.props.title}
              </div>
              {editableInput}
              <div style={controlStyle}>
                <a style={decreaseStyle} onClick={() => this.adjustValue(-1 * this.props.adjustmentAmount)} >-</a>
                <a style={increaseStyle} onClick={() => this.adjustValue(this.props.adjustmentAmount)} >+ </a>
              </div>
            </div>
          )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./react/components/widgets/MdSpinner.tsx